export default __webpack_public_path__ + "static/media/vc-speak-natural.273280b0.png";